import React from 'react';
import TabDataIcon from '../../../../../Common/Icons/TabDataStatus';

type Props = {
  values: any
};

const PropertyGroups = (props: Props) => {
  if (props.values && props.values.property_groups && props.values.property_groups.length > 0) {
    return <TabDataIcon />;
  }
  return null;
}

export default PropertyGroups;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Helpers/TabData/PropertyGroups.tsx